import { PrinterController } from "@/app/ui/controllers/PrinterController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ModalMessageEntities } from "@/domain/entities/MainApp";
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";
import { createI18n } from "vue-i18n";
import { getDataSessionStorage } from '@/app/infrastructures/misc/SessionStorage';

const i18nInstance = createI18n({
  legacy: false,
  locale: getDataSessionStorage("countryCode") || "id",
  fallbackLocale: "id",
  globalInjection: false,
  messages: {
    en,
    id,
    my
  }
});

const translate = i18nInstance.global.t;

const autoPrint = async (stt: string) => {
    const print = await PrinterController.autoPrint({
        id: stt
    });
    return print.data.status;
}

const showLoading = () => {
    MainAppController.showMessageModal(
        new ModalMessageEntities({
            title: String(translate("Menunggu Proses Print")),
            image: "hourglass",
            imageWidth: 90,
            imageHeight: 90,
            message: String(translate("Kami sedang menyiapkan data Anda untuk dicetak")),
        })
    );
} 

const uploadFile = async (file: any, stt: string, isBookInstan: boolean) => {
    if (!isBookInstan) showLoading()
    const filePdf = new File([file], `${stt}.pdf`, {
        type: "application/pdf",
        lastModified: Number(new Date())
    });

    return PrinterController.uploadFile({
        file: filePdf
    }).then(() => {
        return autoPrint(stt);
    }).catch(() => false).finally(() => {
        MainAppController.closeMessageModal();
    });
}

export {
    uploadFile
}

